import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { LanguageService } from 'src/app/services/language/language.service';
import { DocumentNetworkComponent } from './network/document-network.component';

@Component({
    selector: 'app-documents-tabs',
    templateUrl: './documents-tabs.component.html',
    styleUrls: ['./documents-tabs.component.scss'],
    standalone: false
})
export class DocumentsTabsComponent implements OnInit, AfterViewInit {
  readonly TAB = { UPLOAD: 0, VIEWER: 1, OVERVIEW: 2, NETWORK: 3, DETAILS: 4 } as const;
  selectedTabIndex = 0;
  overviewSelectedType: string | null = null;
  networkSelectedDomain: string | null = null;
  networkSelectedSubdomain: string | null = null;
  detailsDocumentIds: string[] = [];

  @ViewChild(DocumentNetworkComponent) networkCmp!: DocumentNetworkComponent;

  constructor(public languageService: LanguageService) {}

  ngOnInit(): void {
    const lastTab = localStorage.getItem('lastDocumentTab');
    if (lastTab !== null) {
      this.selectedTabIndex = +lastTab;
    }
  }

  ngAfterViewInit(): void {
    this.scheduleChartRefresh(this.selectedTabIndex);
  }

  onTabChange(event: any): void {
    this.selectedTabIndex = event.index;
    localStorage.setItem('lastDocumentTab', String(event.index));
    this.scheduleChartRefresh(event.index);
  }

  setOverviewFilter(type: string) {
    this.overviewSelectedType = type;
    this.networkSelectedDomain = null;
    this.detailsDocumentIds = [];
    this.selectedTabIndex = this.TAB.NETWORK;
  }

  setNetworkFilter(domainAndSub: string) {
    // domainAndSub: 'domain' or 'domain|subdomain'
    if (domainAndSub.includes('|')) {
      const [domain, subdomain] = domainAndSub.split('|');
      this.networkSelectedDomain = domain;
      this.networkSelectedSubdomain = subdomain;
      this.overviewSelectedType = null;
      // Obtener IDs de documentos del networkCmp para ese dominio y subdominio
      if (this.networkCmp?.domainMap) {
        const nodes = this.networkCmp.domainMap.nodes.filter(
          n => n.domain === domain && n.subdomain === subdomain
        );
        this.detailsDocumentIds = nodes.map(n => n.id);
      } else {
        this.detailsDocumentIds = [];
      }
      this.selectedTabIndex = this.TAB.DETAILS;
    } else {
      this.networkSelectedDomain = domainAndSub;
      this.networkSelectedSubdomain = null;
      this.overviewSelectedType = null;
      // Obtener IDs de documentos del networkCmp para ese dominio
      if (this.networkCmp?.domainMap) {
        const nodes = this.networkCmp.domainMap.nodes.filter(n => n.domain === domainAndSub);
        this.detailsDocumentIds = nodes.map(n => n.id);
      } else {
        this.detailsDocumentIds = [];
      }
      this.selectedTabIndex = this.TAB.DETAILS;
    }
  }

  translate(key: string): string {
    return this.languageService.translate(key);
  }

  private scheduleChartRefresh(tabIndex: number): void {
    if (tabIndex !== this.TAB.OVERVIEW && tabIndex !== this.TAB.NETWORK) {
      return;
    }

    globalThis.setTimeout(() => {
      globalThis.dispatchEvent(new Event('resize'));

      if (tabIndex === this.TAB.NETWORK && this.networkCmp) {
        this.networkCmp.clearAllFilters();
        this.networkCmp.refreshLayout?.();
      }
    }, 50);
  }
}
